import React, { useEffect, useState } from "react";
import AddAdvance from './add-advance';
import EditAdvance from './edit-advance';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import moment from 'moment';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';


export default function Advances() {
    const [addAdvanceOpen, setAddAdvanceOpen] = useState(false);
    const [editAdvanceOpen, setEditAdvanceOpen] = useState(false);
    const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [recipientTypeFilter, setRecipientTypeFilter] = useState("all");
    const [workerFilter, setWorkerFilter] = useState("all");
    const [advanceTypeFilter, setAdvanceTypeFilter] = useState("all");
    const [editedAdvanceId, setEditedAdvanceId] = useState("");
    const [availableWorkers, setAvailableWorkers] = useState([]);
    const [availableAdmins, setAvailableAdmins] = useState([]);
    const [advancesList, setAdvancesList] = useState([]);
    const api_url = process.env.REACT_APP_API_URL;
    const complexName = localStorage.getItem('complex_name');
    const [totalAdvances, setTotalAdvances] = useState(0);
    const [totalGoods, setTotalGoods] = useState(0);
    const role = localStorage.getItem('role');
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    const handleAddAdvanceOpen = () => setAddAdvanceOpen(true);
    const handleAddAdvanceClose = () => setAddAdvanceOpen(false);

    const handleEditAdvanceOpen = () => setEditAdvanceOpen(true);
    const handleEditAdvanceClose = () => setEditAdvanceOpen(false);

    function showEditAdvanceModal(advance_id){
        handleEditAdvanceOpen();
        setEditedAdvanceId(advance_id);
    }

    function showAddAdvanceModal(){
        handleAddAdvanceOpen();
    }

    React.useEffect(() => {
        async function getAvailableWorkers() {
            const requestOptions = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
              body: JSON.stringify({ complex_name: complexName })
            };
            const availableWorkers = await (await fetch(api_url+"/api/allLiveWorkers", requestOptions)).json();
            setAvailableWorkers(availableWorkers.map(({worker_id, full_name, rank, phone_number, complex_name, role}) => ({workerId: worker_id, fullName: full_name, rank: rank, phoneNumber: phone_number, complexName: complex_name, role: role})));
        }

        async function getAvailableAdmins() {
            const requestOptions = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
              body: JSON.stringify({ complex_name: complexName })
            };
            const body = await (await fetch(api_url+"/api/availableAdmins", requestOptions)).json();
            setAvailableAdmins(body.map(({ user_id, fullname }) => ({ userId: user_id, fullName: fullname })));
        }

        async function getAdvances() {
          const requestBody = {
            start_date: startDate,
            end_date: endDate,
            complex_name: complexName,
            advance_type: advanceTypeFilter,
            recipient_type_filter: recipientTypeFilter
          };
          if (recipientTypeFilter === 'worker') {
            requestBody.worker_id = workerFilter;
          } else if (recipientTypeFilter === 'user') {
            requestBody.user_id = workerFilter;
          }

          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')},
            body: JSON.stringify(requestBody)
          };
          setLoading(true);
          try {
            const advances_list = await fetch(api_url+"/api/allAdvances", requestOptions);
            const body = await advances_list.json();
            setAdvancesList(body.map(({ advance_id, advance_date, worker_id, user_id, recipient_type, full_name, advance_amount, complex_name, comment, created_by, advance_type }) => ({ advance_id: advance_id, advance_date: new Date(advance_date).toLocaleString("ru-RU", { timeZone: "UTC" }), worker_id: worker_id, user_id: user_id, recipient_type: recipient_type, worker_name: full_name, advance_amount: advance_amount, complex_name: complex_name, comment: comment, created_by: created_by, advance_type: advance_type || 'advance' })));

            let temp_total_advances = 0;
            let temp_total_goods = 0;
            for(var i=0; i < body.length; i++){
              if (body[i].advance_type === 'goods') {
                temp_total_goods += body[i].advance_amount;
              } else {
                temp_total_advances += body[i].advance_amount;
              }
            }

            setTotalAdvances(temp_total_advances);
            setTotalGoods(temp_total_goods);
          } finally {
            setLoading(false);
          }
        }
        getAvailableWorkers();
        getAvailableAdmins();
        getAdvances();

        }, [startDate, endDate, workerFilter, advanceTypeFilter, recipientTypeFilter, addAdvanceOpen, editAdvanceOpen]);

    return (
        <>
            <Box sx={{pt:5, pb:5}} fullWidth>
            <TextField
                id="start_date"
                label="Дата с"
                type="date"
                defaultValue={startDate}
                sx={{ m: 1.5, width: 220}}
                InputLabelProps={{
                    shrink: true,
                }}
                onChange={e => { setStartDate(e.target.value); setPage(0); }}
            />

            <TextField
                id="end_date"
                label="Дата по"
                type="date"
                defaultValue={endDate}
                sx={{ m: 1.5, width: 220 }}
                InputLabelProps={{
                    shrink: true,
                }}
                onChange={e => { setEndDate(e.target.value); setPage(0); }}
            />

            <FormControl sx={{m: 1.5, width: 220}} >
            <InputLabel id="recipient-type-filter-label">Тип сотрудника</InputLabel>
            <Select
                id="recipient_type_filter"
                value={recipientTypeFilter}
                label="Тип сотрудника"
                onChange={e => {
                    setRecipientTypeFilter(e.target.value);
                    setWorkerFilter("all");
                    setPage(0);
                }}
            >
            <MenuItem value="all">Все</MenuItem>
            <MenuItem value="worker">Мойщик/Кассир/КК</MenuItem>
            <MenuItem value="user">Админ/HR-директор</MenuItem>
            </Select>
            </FormControl>

            {recipientTypeFilter !== 'all' && (
            <FormControl sx={{m: 1.5, width: 250}} >
            <InputLabel id="worker-filter-label">Выберите сотрудника</InputLabel>
            <Select
                id="worker_name"
                value={workerFilter}
                label="Выберите сотрудника"
                onChange={e => { setWorkerFilter(e.target.value); setPage(0); }}
            >
            <MenuItem value="all">Любой</MenuItem>
            {recipientTypeFilter === 'worker'
                ? availableWorkers.map((item) => (
                    <MenuItem key={item.workerId} value={item.workerId}>{item.fullName}</MenuItem>
                  ))
                : availableAdmins.map((item) => (
                    <MenuItem key={item.userId} value={item.userId}>{item.fullName}</MenuItem>
                  ))
            }
            </Select>
            </FormControl>
            )}

            <FormControl sx={{m: 1.5, width: 200}} >
            <InputLabel id="advance-type-filter-label">Тип записи</InputLabel>
            <Select
                id="advance_type_filter"
                value={advanceTypeFilter}
                label="Тип записи"
                onChange={e => { setAdvanceTypeFilter(e.target.value); setPage(0); }}
            >
            <MenuItem value="all">Все</MenuItem>
            <MenuItem value="advance">Авансы</MenuItem>
            <MenuItem value="goods">Товары</MenuItem>
            </Select>
            </FormControl>
            </Box>

            {(role === "1" || role === "2") &&
            <button className='add-visit-button' onClick={() => showAddAdvanceModal()}>
                <a>Добавить аванс</a>
            </button>}

            <Typography m={5} variant="h6">
                Авансы: {totalAdvances} | Товары: {totalGoods} | Всего: {totalAdvances + totalGoods}
            </Typography>

            <TableContainer component={Paper} sx={{ maxHeight: 640 }}>
            <Table stickyHeader sx={{ minWidth: 650 }} aria-label="advances table">
            <TableHead>
            <TableRow>
                <TableCell>Дата</TableCell>
                <TableCell>Сотрудник</TableCell>
                <TableCell>Тип</TableCell>
                <TableCell align="right">Сумма</TableCell>
                <TableCell>Комментарий</TableCell>
                <TableCell>Добавил</TableCell>
                <TableCell></TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {loading ? (
                <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 6 }}><CircularProgress size={28} /></TableCell>
                </TableRow>
            ) : advancesList.length === 0 ? (
                <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 6, color: 'text.secondary' }}>Нет записей за выбранный период</TableCell>
                </TableRow>
            ) : advancesList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(({advance_date, advance_id, worker_name, advance_amount, comment, created_by, advance_type}) => (
            <TableRow key={advance_id} hover>
                <TableCell>{advance_date}</TableCell>
                <TableCell>{worker_name}</TableCell>
                <TableCell>{advance_type === 'goods' ? 'Товары' : 'Аванс'}</TableCell>
                <TableCell align="right">{advance_amount}</TableCell>
                <TableCell sx={{whiteSpace: "normal", wordWrap: "break-word"}}>{comment}</TableCell>
                <TableCell>{created_by || '-'}</TableCell>
                <TableCell>
                <Button
                    variant="outlined"
                    onClick={() => showEditAdvanceModal(advance_id)}>Изменить</Button>
                </TableCell>
            </TableRow>
            ))}
            </TableBody>
            </Table>
            </TableContainer>
            {!loading && advancesList.length > 0 && (
            <TablePagination
                component="div"
                count={advancesList.length}
                page={page}
                onPageChange={(e, p) => setPage(p)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
                rowsPerPageOptions={[10, 25, 50, 100]}
                labelRowsPerPage="Строк на странице:"
            />
            )}

            <Modal
            open={addAdvanceOpen}
            onClose={handleAddAdvanceClose}
            >
            <AddAdvance availableWorkers={availableWorkers}/>
            </Modal>

            <Modal
            open={editAdvanceOpen}
            onClose={handleEditAdvanceClose}
            >
            <EditAdvance editedAdvanceId={editedAdvanceId} availableWorkers={availableWorkers}/>
            </Modal>
        </>
    )
}


